export default {"src":"/_next/static/media/sports.c670a039.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};